<template>
  <div class="product">
    <banner img="../assets/img/bgtop.jpg" :title="currentProduct.name || '产品中心'" />
    <transition name="fade">
      <div class="case-product" v-loading="loading">
        <div class="content-left">
          <el-menu
            :default-active="menuActiveIndex"
            class="el-menu-vertical-demo"
            @select="handleProductSelect"
            @open="onSubmenuOpen"
            :collapse="false"
            :unique-opened="true"
            ref="leftMenu"
            active-text-color="#0f87ff"
          >
            <template v-for="(menu, i) in productList">
              <el-submenu v-if="menu.key === 'conveyor'" :index="String(i)" :key="menu.key" class="submenu-conveyor">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span>{{ menu.name }}</span>
                </template>
                <el-menu-item
                  v-for="(m, idx) in conveyorSubmodules"
                  :index="'conveyor:' + idx"
                  :key="m.key"
                >
                  <span>{{ m.name }}</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu v-if="menu.key === 'warehouse'" :index="String(i)" :key="menu.key" class="submenu-warehouse">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span>{{ menu.name }}</span>
                </template>
                <el-menu-item
                  v-for="(m, idx) in warehouseSubmodules"
                  :index="'warehouse:' + idx"
                  :key="m.key"
                >
                  <span>{{ m.name }}</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu v-if="menu.key === 'agv'" :index="String(i)" :key="menu.key" class="submenu-agv">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span>{{ menu.name }}</span>
                </template>
                <el-menu-item
                  v-for="(m, idx) in agvSubmodules"
                  :index="'agv:' + idx"
                  :key="m.key"
                >
                  <span>{{ m.name }}</span>
                </el-menu-item>
              </el-submenu>

              <el-menu-item v-if="menu.key !== 'conveyor' && menu.key !== 'warehouse' && menu.key !== 'agv'" :index="String(i)" :key="menu.key">
                <i class="el-icon-menu"></i>
                <span>{{ menu.name }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </div>

        <div class="content-right">
          <div class="case-content">
            <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
              <swiper-slide
                class="swiper-slide slide-one"
                v-for="(mod, index) in productList"
                :key="mod.key"
                @click="onSlideClick(mod, index)"
              >
                <img :src="mod.imgLists[0]" alt="" />
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>

          <div v-if="currentProduct.html" v-html="currentProduct.html"></div>
          <div v-else class="p-details">{{ currentProduct.detailsText }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  data() {
    return {
      loading: false,
      menuActiveIndex: "0",
      videoSrc: "http://www.shkjem.com/video/kj.mp4",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://www.shkjem.com/video/kj.mp4", //url地址
          },
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
      swiperActiveIndex: 0,
      swiperOption: {
        autoplay: false,
        loop: false,
        speed: 500,
        initialSlide: 0,
        grabCursor: false, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        // notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        // direction: "vertical", //水平方向移动
        // autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        // slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        // height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        pagination: {
          el: ".swiper-pagination",
          // type: 'fraction',
          clickable: true,
        },
        on: {
          // 滚动(进行时)事件
          slideChangeTransitionStart: () => {},
          // 滚动(结束时)事件
          slideChangeTransitionEnd: () => {
            this.$nextTick(() => {
              this.swiperActiveIndex = this.$refs.mySwiper.swiper.activeIndex;
              const mod = this.productList[this.swiperActiveIndex];
              if (mod && this.$route.query.id !== mod.key) {
                this.$router.push({ path: "product2", query: { id: mod.key } });
              }
            });
          },
        },
      },

      currentProduct: {
        name: "产品中心",
        imgLists: [],
        detailsText: "",
      },
      productIndex: 1,
      conveyorActiveIndex: 0,
      conveyorSubmodules: [
        {
          name: "电子行业",
          key: "electronic",
          img: require("@/assets/img/Product Center/Conveyor system/电子.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">电子行业</div>
            </div>
          `,
        },
       
        {
          name: "日化行业",
          key: "daily_chemicals",
          img: require("@/assets/img/Product Center/Conveyor system/日化.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">日化行业</div>
            </div>
          `,
        },
        {
          name: "生活用纸行业",
          key: "tissue",
          img: require("@/assets/img/Product Center/Conveyor system/生活用纸.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">生活用纸行业</div>
            </div>
          `,
        },
        {
          name: "食品行业",
          key: "food",
          img: require("@/assets/img/Product Center/Conveyor system/食品.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">食品行业</div>
            </div>
          `,
        },
        
        {
          name: "医药行业",
          key: "pharma",
          img: require("@/assets/img/Product Center/Conveyor system/医药.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">医药行业</div>
            </div>
          `,
        },
         {
          name: "螺旋塔",
          key: "spiral_tower",
          img: require("@/assets/img/Product Center/Conveyor system/螺旋塔.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">螺旋塔</div>
            </div>
          `,
        },
        {
          name: "提升机",
          key: "elevator",
          img: require("@/assets/img/Product Center/Conveyor system/提升机.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">提升机</div>
            </div>
          `,
        },
      ],
      warehouseActiveIndex: 0,
      warehouseSubmodules: [
        {
          name: "轻型仓储",
          key: "light",
          img: require("@/assets/img/Product Center/Warehouse System/轻型仓储.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">轻型仓储</div>
            </div>
          `,
        },
        {
          name: "智能仓储系统",
          key: "smart",
          img: require("@/assets/img/Product Center/Warehouse System/智能仓储系统.png"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">智能仓储系统</div>
            </div>
          `,
        },
      ],
      agvActiveIndex: 0,
      agvSubmodules: [
        {
          name: "叉车AGV",
          key: "forklift",
          img: require("@/assets/img/Product Center/AGV/叉车AGV.jpg"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">叉车AGV</div>
            </div>
          `,
        },
        {
          name: "复合移动机器人",
          key: "compound",
          img: require("@/assets/img/Product Center/AGV/复合移动机器人.jpg"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">复合移动机器人</div>
            </div>
          `,
        },
        {
          name: "高位料箱AGV",
          key: "high_box",
          img: require("@/assets/img/Product Center/AGV/高位料箱AGV.jpg"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">高位料箱AGV</div>
            </div>
          `,
        },
        {
          name: "潜伏AGV",
          key: "lurking",
          img: require("@/assets/img/Product Center/AGV/潜伏AGV.jpg"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">潜伏AGV</div>
            </div>
          `,
        },
        {
          name: "移载AGV",
          key: "transfer",
          img: require("@/assets/img/Product Center/AGV/移载AGV.jpg"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">移载AGV</div>
            </div>
          `,
        },
        {
          name: "重载AGV",
          key: "heavy",
          img: require("@/assets/img/Product Center/AGV/重载AGV.jpg"),
          html: `
            <div v-else class="p-title">
              <div class="title-head">重载AGV</div>
            </div>
          `,
        },
      ],
      productList: [
        {
          name: "柔性物流输送系统",
          key: "conveyor",
          imgLists: [
            require("@/assets/img/Product Center/Conveyor system/电子.png"),
          ],
          dropdownDir: "@/assets/img/Product Center/Conveyor system",
         // detailsText: "xxx",
          title: "柔性物流输送系统",
              html: `
            <div v-else class="p-title">
              <div class="title-head">柔性物流输送系统</div>
            
            </div>
          `,
        },
        {
          name: "自动装箱机",
          key: "packer",
          imgLists: [
            require("@/assets/img/Product Center/装箱机.jpg"),
          ],
          
          //detailsText: "xxx",
          title: "自动装箱机",
          html: `
            <div v-else class="p-title">
              <div class="title-head">自动装箱机</div>
            
            </div>
          `,
        },
        {
          name: "机器人码垛系统",
          key: "palletizing",
          imgLists: [
            require("@/assets/img/Product Center/码垛机器人.png"),
          ],
          //detailsText: "xxx",
          title: "机器人码垛系统",
          html: `
            <div v-else class="p-title">
              <div class="title-head">机器人码垛系统</div>
            
            </div>
          `,
        },
        {
          name: "智能仓储系统",
          key: "warehouse",
          imgLists: [
            require("@/assets/img/Product Center/Warehouse System/轻型仓储.png"),
            //  require("@/assets/img/case/demo.png"),
          ],
          dropdownDir: "@/assets/img/Product Center/Warehouse System",
         // detailsText: "xxx",
          title: "智能仓储系统",
          html: `
            <div v-else class="p-title">
              <div class="title-head">智能仓储系统</div>
            
            </div>
          `,
        },
        {
          name: "AGV",
          key: "agv",
          imgLists: [
            require("@/assets/img/Product Center/AGV/叉车AGV.jpg"),
          ],
          dropdownDir: "@/assets/img/Product Center/AGV",
          //detailsText: "xxx",
          title: "AGV模块",
          html: `
            <div v-else class="p-title">
              <div class="title-head">AGV</div>
            
            </div>
          `,
        },
      ],
    };
  },
  components: {
    Banner,
  },
  created() {
    // this.$http
    //   .get(
    //     "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
    //   )
    //   .then(response => {
    //     this.videoSrc = response.data[0].Content;
    //     window.console.log(this.videoSrc);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  },

  watch: {
    $route: {
      handler: function (newProductRoute) {
        if (!newProductRoute.query.id) return;
        this.productIndex = newProductRoute.query.id;

        this.currentProduct = this.productList.find(
          (item) => item.key == newProductRoute.query.id
        );
        const idx = this.productList.findIndex(
          (item) => item.key == newProductRoute.query.id
        );
        this.menuActiveIndex = String(idx >= 0 ? idx : 0);
        if (idx >= 0) {
          this.$nextTick(() => {
            this.$refs.mySwiper.swiper.slideTo(idx, 500, false);
            const key = this.productList[idx] && this.productList[idx].key;
            if (this.$refs.leftMenu && (key === 'conveyor' || key === 'warehouse' || key === 'agv')) {
              this.$refs.leftMenu.open(String(idx));
            }
            if (key === 'conveyor') {
              this.conveyorActiveIndex = 0;
              this.menuActiveIndex = 'conveyor:0';
              this.applyConveyorSelection();
            } else if (key === 'warehouse') {
              this.warehouseActiveIndex = 0;
              this.menuActiveIndex = 'warehouse:0';
              this.applyWarehouseSelection();
            } else if (key === 'agv') {
              this.agvActiveIndex = 0;
              this.menuActiveIndex = 'agv:0';
              this.applyAgvSelection();
            } else {
              this.closeAllSubmenus();
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onSubmenuOpen(index) {
      const i = Number(index);
      const menu = this.productList[i];
      if (!menu) return;
      if (menu.key === 'conveyor') {
        this.conveyorActiveIndex = 0;
        this.menuActiveIndex = 'conveyor:0';
        this.applyConveyorSelection();
      } else if (menu.key === 'warehouse') {
        this.warehouseActiveIndex = 0;
        this.menuActiveIndex = 'warehouse:0';
        this.applyWarehouseSelection();
      } else if (menu.key === 'agv') {
        this.agvActiveIndex = 0;
        this.menuActiveIndex = 'agv:0';
        this.applyAgvSelection();
      }
      this.$nextTick(() => {
        if (i >= 0 && this.$refs.mySwiper) {
          this.$refs.mySwiper.swiper.slideTo(i, 500, false);
        }
        if (menu && this.$route.query.id !== menu.key) {
          this.$router.push({ path: 'product2', query: { id: menu.key } });
        }
      });
    },
    handleProductSelect(index) {
      if (String(index).indexOf('conveyor:') === 0) {
        const subIdx = Number(String(index).split(':')[1] || 0);
        this.conveyorActiveIndex = isNaN(subIdx) ? 0 : subIdx;
        this.menuActiveIndex = 'conveyor:' + this.conveyorActiveIndex;
        const i = this.productList.findIndex((p) => p.key === 'conveyor');
        if (i >= 0) {
          this.$router.push({ path: "product2", query: { id: 'conveyor' } });
          this.$nextTick(() => {
            this.$refs.mySwiper.swiper.slideTo(i, 500, false);
          });
        }
        this.applyConveyorSelection();
        return;
      }
      if (String(index).indexOf('agv:') === 0) {
        const subIdx = Number(String(index).split(':')[1] || 0);
        this.agvActiveIndex = isNaN(subIdx) ? 0 : subIdx;
        this.menuActiveIndex = 'agv:' + this.agvActiveIndex;
        const i = this.productList.findIndex((p) => p.key === 'agv');
        if (i >= 0) {
          this.$router.push({ path: "product2", query: { id: 'agv' } });
          this.$nextTick(() => {
            this.$refs.mySwiper.swiper.slideTo(i, 500, false);
          });
        }
        this.applyAgvSelection();
        return;
      }
      if (String(index).indexOf('warehouse:') === 0) {
        const subIdx = Number(String(index).split(':')[1] || 0);
        this.warehouseActiveIndex = isNaN(subIdx) ? 0 : subIdx;
        this.menuActiveIndex = 'warehouse:' + this.warehouseActiveIndex;
        const i = this.productList.findIndex((p) => p.key === 'warehouse');
        if (i >= 0) {
          this.$router.push({ path: "product2", query: { id: 'warehouse' } });
          this.$nextTick(() => {
            this.$refs.mySwiper.swiper.slideTo(i, 500, false);
          });
        }
        this.applyWarehouseSelection();
        return;
      }
      const i = Number(index);
      const target = this.productList[i];
      if (!target) return;
      this.$router.push({ path: "product2", query: { id: target.key } });
      this.$nextTick(() => {
        this.$refs.mySwiper.swiper.slideTo(i, 500, false);
        if (target.key === 'conveyor') {
          this.conveyorActiveIndex = 0;
          this.menuActiveIndex = 'conveyor:0';
          this.applyConveyorSelection();
          if (this.$refs.leftMenu) this.$refs.leftMenu.open(String(i));
        } else if (target.key === 'warehouse') {
          this.warehouseActiveIndex = 0;
          this.menuActiveIndex = 'warehouse:0';
          this.applyWarehouseSelection();
          if (this.$refs.leftMenu) this.$refs.leftMenu.open(String(i));
        } else if (target.key === 'agv') {
          this.agvActiveIndex = 0;
          this.menuActiveIndex = 'agv:0';
          this.applyAgvSelection();
          if (this.$refs.leftMenu) this.$refs.leftMenu.open(String(i));
        } else {
          this.closeAllSubmenus();
        }
      });
    },
    onSlideClick(mod, index) {
      this.$router.push({ path: "product2", query: { id: mod.key } });
      this.$nextTick(() => {
        this.$refs.mySwiper.swiper.slideTo(index, 500, false);
      });
    },
    onConveyorChange() {
      this.applyConveyorSelection();
    },
    applyConveyorSelection() {
      const sel = this.conveyorSubmodules[this.conveyorActiveIndex] || this.conveyorSubmodules[0];
      const conveyorIdx = this.productList.findIndex((p) => p.key === 'conveyor');
      if (conveyorIdx >= 0 && sel) {
        this.$set(this.productList[conveyorIdx].imgLists, 0, sel.img);
        if (this.currentProduct && this.currentProduct.key === 'conveyor') {
          this.currentProduct.html = sel.html;
        }
      }
    },
    applyAgvSelection() {
      const sel = this.agvSubmodules[this.agvActiveIndex] || this.agvSubmodules[0];
      const agvIdx = this.productList.findIndex((p) => p.key === 'agv');
      if (agvIdx >= 0 && sel) {
        this.$set(this.productList[agvIdx].imgLists, 0, sel.img);
        if (this.currentProduct && this.currentProduct.key === 'agv') {
          this.currentProduct.html = sel.html;
        }
      }
    },
    applyWarehouseSelection() {
      const sel = this.warehouseSubmodules[this.warehouseActiveIndex] || this.warehouseSubmodules[0];
      const warehouseIdx = this.productList.findIndex((p) => p.key === 'warehouse');
      if (warehouseIdx >= 0 && sel) {
        this.$set(this.productList[warehouseIdx].imgLists, 0, sel.img);
        if (this.currentProduct && this.currentProduct.key === 'warehouse') {
          this.currentProduct.html = sel.html;
        }
      }
    },
    closeAllSubmenus() {
      const keys = ['conveyor', 'warehouse', 'agv'];
      keys.forEach((k) => {
        const idx = this.productList.findIndex((p) => p.key === k);
        if (idx >= 0 && this.$refs.leftMenu) {
          this.$refs.leftMenu.close(String(idx));
        }
      });
    },
  },
};
</script>

<style lang="scss">
.p-title {
  width: 1000px;
  margin: 0 auto;
  padding-bottom: 50px;
  box-sizing: border-box;
  .title-font {
    font-size: 28px;
    font-weight: 400;
    color: #333;
    line-height: 1.6;
  }
  .title-head {
    font-size: 26px;
    font-weight: 400;
    color: #e13834;
    line-height: 2;
    // line-height: 52px;
  }
  .title-text {
    font-size: 22px;
    color: #14679f;
    line-height: 1.4;
    &::before {
      content: "";
      width: 10px;
      display: inline-block;
    }
    .title-img img {
      word-wrap: break-word;
      // float: right;
      width: 120px;
      height: 120px;
    }
  }
}
</style>

<style lang="scss" scoped>
.swiper-pagination {
  top: 0;
  left: 0;
  height: 350px;
}

.swiper-slide {
  width: 100%;
  height: 450px;//350
  // height: 400px;
  // background: #e13834;
  img {
    width: 100%;
    height: 350px;
    object-fit: fill;
  }
}

.submenu-conveyor ::v-deep .el-submenu__icon-arrow {
  display: none !important;
}
.submenu-warehouse ::v-deep .el-submenu__icon-arrow {
  display: none !important;
}
.submenu-agv ::v-deep .el-submenu__icon-arrow {
  display: none !important;
}

.product {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  .case-product {
    width: 1240px;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .content-left {
      width: 260px;
      height: 100%;
      padding: 20px;
      box-sizing: border-box;
    }
    .content-right {
      width: 1000px;//964
      padding: 20px 20px;
      box-sizing: border-box;
      .case-content {
        width: 100%;
        .swiper-slide img {
          width: 100%;
          height: 370px;//450
          object-fit: fill;
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.p-dropdown {
  width: 1000px;
  margin: 0 auto;
  padding: 20px 0;
}
.p-preview {
  width: 1000px;
  margin: 0 auto;
}
.p-preview img {
  width: 100%;
  max-height: 400px;
  object-fit: contain;
}
.p-details {
  width: 1000px;
  margin: 20px auto;
  font-size: 18px;
  color: #14679f;
}

@media (max-width: 768px) {
  .product-content {
    width: 100%;
  }
  .p-video,
  .p-dropdown,
  .p-preview,
  .p-details {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
  }
}
</style>
